import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Locality from "../views/Locality";
import EventBus from "../components/EventBus";
import NotFound from "../views/NotFound"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/locality',
        name: 'Locality',
        props: true,
        component: Locality
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound
    }
]

const router = new VueRouter({
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    EventBus.$emit("PRELOADER_SHOW");
    setTimeout(() => {
        next();
    }, 300)
})

export default router
